import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { Col, Form, Row, Select, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Box, DialogActions } from '@mui/material';
import UpdateButton from 'components/button/UpdateButton';
import NextPrevButton from 'components/button/NextPrevButton';
import comptroller from 'assets/images/comptroller_white.svg';
import CustomTextInput from 'components/inputs/CustomTextInput';
import CustomInputLabel from 'components/Label/CustomInputLabel';
import ActiveEditButton from 'components/button/ActiveEditButton';
import CustomSelectInput from 'components/inputs/CustomSelectInput';
import ComptrollerActiveButton from 'components/button/ComptrollerActivateButton';
import ComptrollerModalContainer from 'components/modal/ComptrollerModalContainer';
import { taskNatureData, timelineBasisData, triggeringActionData } from './Create';
import ModalActivationStatusInput from 'components/modal/ModalActivationStatusInput';
import ComptrollerModalFooterActionButton from 'components/button/ComptrollerModalFooterActionButton';
import { useSetServiceLevelActiveMutation, useUpdateSingleServiceLevelMutation } from 'store/features/comptroller/comptrollerApi';

const ServiceLevelEditModal = ({ type, setType, dataList, editItem, showModal, setEditItem, navigateLink, setReloadTable }) => {
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const [activate, setActivate] = useState(true);
	const [isLoading, setIsLoading] = useState(true);
	const [screenSize, setScreenSize] = useState('lg');
	const [confirmModal, setConfirmModal] = useState(false);
	const [formSubmitData, setFormSubmitData] = useState(null);
	const [modalData, setModalData] = useState({ head: 'Confirmation', label: 'Do you want to update?' });
	const [counter, setCounter] = useState({
		taskType: 0,
		dayCount: 0,
		action: 0,
	});
	const [pagination, setPagination] = useState({
		lastPage: 0,
		firstPage: 0,
		currentPage: 0,
	});

	const [UpdateSingleServiceLevel, { error: updateErrorRes, isSuccess: isUpdateSuccess, isError: isUpdateError }] =
		useUpdateSingleServiceLevelMutation();
	const [SetServiceLevelActive, { data: activationRes, isSuccess: isActivationSuccess, isError: isActivationError }] =
		useSetServiceLevelActiveMutation();

	const setFormFieldsValue = (editItem) => {
		form.setFieldsValue({
			taskType: editItem?.taskType,
			dayCount: editItem?.dayCount,
			action: editItem?.action,
			code: editItem?.code,
			activationStatus: editItem?.activationStatus,
		});
	};

	const handleClose = () => {
		if (type === 'Edit') {
			setCounter({});
			setType('View');

			setFormFieldsValue(editItem);
		} else {
			setEditItem(null);
			setType('View');
		}
	};

	const handleSubmit = (data) => {
		setConfirmModal(true);

		if (type === 'Edit') {
			setFormSubmitData(data);

			setModalData({ head: 'Confirmation', label: 'Do you want to Update?' });
		} else {
			setModalData({ head: 'Confirmation', label: `Do you want to ${data?.activationStatus === 'Active' ? 'Deactivate' : 'Active'}?` });
		}
	};

	const handleUpdate = (data) => {
		if (editItem?.id) {
			const payload = {
				id: editItem?.id,
				...data,
			};

			UpdateSingleServiceLevel(payload);
		}
	};

	const handleDeactivate = () => {
		const payload = {
			id: editItem?.id,
			activationStatus: editItem?.activationStatus === 'Active' ? 'Inactive' : 'Active',
		};

		SetServiceLevelActive(payload);
	};

	const onFieldsChange = (e) => {
		if (editItem) {
			if (e[0]?.name[0] === 'action') {
				if (e[0]?.value !== editItem?.action) {
					setCounter({
						...counter,
						action: 1,
					});
				} else {
					setCounter({
						...counter,
						action: 0,
					});
				}
			} else if (e[0]?.name[0] === 'dayCount') {
				if (e[0]?.value !== editItem?.dayCount) {
					setCounter({
						...counter,
						dayCount: 1,
					});
				} else {
					setCounter({
						...counter,
						dayCount: 0,
					});
				}
			} else if (e[0]?.name[0] === 'taskType') {
				if (e[0]?.value !== editItem?.taskType) {
					setCounter({
						...counter,
						taskType: 1,
					});
				} else {
					setCounter({
						...counter,
						taskType: 0,
					});
				}
			}
		}
	};

	useEffect(() => {
		if (counter?.taskType === 1 || counter?.dayCount === 1 || counter?.action === 1) {
			setActivate(false);
		} else {
			setActivate(true);
		}
	}, [counter?.taskType, counter?.dayCount, counter?.action]);

	useEffect(() => {
		if (editItem) {
			// form.setFieldsValue({
			// 	taskType: editItem?.taskType,
			// 	dayCount: editItem?.dayCount,
			// 	action: editItem?.action,
			// 	code: editItem?.code,
			// 	activationStatus: editItem?.activationStatus,
			// });

			setFormFieldsValue(editItem);

			setIsLoading(false);
		}
	}, [editItem, form]);

	useEffect(() => {
		if (isUpdateSuccess) {
			toast.success('Success! Action completed.', toastConfig);

			if (!navigateLink) {
				setType('View');
				setReloadTable((prev) => !prev);
			} else {
				navigate(navigateLink);
			}

			setEditItem(null);
		} else if (isUpdateError) {
			if (updateErrorRes?.code === '502') {
				toast.error(updateErrorRes?.message, toastConfig);
			} else {
				toast.error('Failure! Action not completed.', toastConfig);
			}
		}
	}, [isUpdateSuccess, isUpdateError]);

	useEffect(() => {
		if (isActivationSuccess) {
			toast.success('Success! Action completed.', toastConfig);

			if (!navigateLink) {
				setType('View');
				setReloadTable((prev) => !prev);
			} else {
				navigate(navigateLink);
			}

			setEditItem(null);
		} else if (isActivationError) {
			if (activationRes?.code === '502') {
				toast.error(activationRes?.message, toastConfig);
			} else {
				toast.error('Failure! Action not completed.', toastConfig);
			}
		}
	}, [isActivationSuccess, isActivationError]);

	useEffect(() => {
		if (dataList?.length > 0 && editItem) {
			const currentItemIndex = dataList?.findIndex((item) => item.id === editItem?.id);

			setPagination({
				firstPage: 0,
				currentPage: currentItemIndex,
				lastPage: dataList?.length - 1,
			});
		}
	}, []);

	return (
		<Spin spinning={isLoading}>
			<ComptrollerModalContainer
				type={type}
				form={form}
				showModal={showModal}
				modalData={modalData}
				screenSize={screenSize}
				handleClose={handleClose}
				confirmModal={confirmModal}
				handleSubmit={handleSubmit}
				handleUpdate={handleUpdate}
				setScreenSize={setScreenSize}
				title="Service Level Agreement"
				onFieldsChange={onFieldsChange}
				formSubmitData={formSubmitData}
				setConfirmModal={setConfirmModal}
				handleDeactivate={handleDeactivate}
			>
				<ComptrollerActiveButton activationStatus={editItem?.activationStatus} type={type} deactivateHandler={() => handleSubmit(editItem)} />
				<Row gutter={[16, 0]}>
					<Col xs={24}>
						<CustomTextInput form={form} name="code" label="Code" disabled={true} placeholder="Auto Generated" />
					</Col>

					<Col xs={24}>
						<CustomSelectInput
							name="taskType"
							label="Task Nature"
							disabled={type === 'View' ? true : false}
							value={editItem?.taskType}
							rules={[
								{
									required: true,
								},
							]}
						>
							{taskNatureData.map((value, index) => (
								<Select.Option key={index} value={value?.value}>
									{value?.label}
								</Select.Option>
							))}
						</CustomSelectInput>
					</Col>

					<Col xs={24}>
						<CustomSelectInput
							name="dayCount"
							label="Timeline Basis"
							disabled={type === 'View' ? true : false}
							// value={timelineBasisData?.find((item) => item?.value === form?.getFieldValue('dayCount'))?.label}
							rules={[
								{
									required: true,
								},
							]}
						>
							{timelineBasisData.map((value, index) => (
								<Select.Option key={index} value={value?.value}>
									{value?.label}
								</Select.Option>
							))}
						</CustomSelectInput>
					</Col>

					<Col xs={24}>
						<CustomSelectInput
							name="action"
							label="SLA Triggering Action"
							disabled={type === 'View' ? true : false}
							value={editItem?.action}
							rules={[
								{
									required: true,
								},
							]}
						>
							{triggeringActionData.map((value, index) => (
								<Select.Option key={index} value={value?.value}>
									{value?.label}
								</Select.Option>
							))}
						</CustomSelectInput>
					</Col>

					<ModalActivationStatusInput name="activationStatus" activationStatus={editItem?.activationStatus} />
				</Row>

				<ComptrollerModalFooterActionButton
					type={type}
					setType={setType}
					dataList={dataList}
					editItem={editItem}
					activate={activate}
					pagination={pagination}
					setEditItem={setEditItem}
					setIsLoading={setIsLoading}
					setPagination={setPagination}
				/>

				{/* <DialogActions sx={{ px: 0, pb: 4, pt: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
						{type === 'View' && (
							<ActiveEditButton
								editNavigation={() => {
									setType('Edit');
								}}
							/>
						)}

						{type === 'Edit' && <UpdateButton title="Update" disabled={activate} />}
					</Box>

					<NextPrevButton
						type={type}
						dataList={dataList}
						editItem={editItem}
						pagination={pagination}
						setEditItem={setEditItem}
						setIsLoading={setIsLoading}
						setPagination={setPagination}
					/>
				</DialogActions> */}
			</ComptrollerModalContainer>
		</Spin>
	);
};
export default ServiceLevelEditModal;
